export default "__VITE_ASSET__ChFjvLC2__"